import { DialogContent } from "@material-ui/core";

function MaterialDialogContent ( props ) {

    return <DialogContent {...props} />
    
}

export default MaterialDialogContent;
